export default __webpack_public_path__ + "static/media/squarebtn.94d1cc58.svg";